import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from 'src/i18n';
import { locale } from "../modules/language";
import { setQuasarInternalLanguage } from "../modules/quasarInternalLanguage";
import { WordReplacer } from "../modules/word-replacer";
import baseDictionary from "../i18n/Words";
Vue.use(VueI18n);
var localeSelected = localStorage.getItem('locale');
/** @type {string} */

var currentLocale = localeSelected || locale;
var cookieLocale = currentLocale.toLowerCase().slice(0, 2);
document.cookie = "django_language=".concat(cookieLocale, ";");
var replacer = new WordReplacer(messages, baseDictionary[currentLocale]);
var i18n = new VueI18n({
  locale: currentLocale,
  messages: replacer.messages
});

var setLocaleMessage = function setLocaleMessage(value) {
  i18n.setLocaleMessage(currentLocale, value[currentLocale]);
};

setQuasarInternalLanguage(currentLocale);
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var app;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            app = _ref.app;
            app.i18n = i18n;

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();
export { i18n, setLocaleMessage, replacer };